import moment from 'moment';

export function timeFromNow(datetime) {
    const now = moment();
    const then = moment(datetime);
    const duration = moment.duration(now.diff(then));
    const hours = duration.hours();
    const minutes = duration.minutes();
    return `${hours !== 0 ? hours + "h" : ""} ${minutes}m`;
  };